import Axios from "../../../../api/axios/Axios";

export const getChannelStreams = (username, { limit = 12, offset = 0 } = {}) =>
  Axios.get(`/api/channels/${encodeURIComponent(username)}/streams`, {
    params: { limit, offset },
  });

export const getChannelStreamPlay = (username, streamSessionId, signal) =>
  Axios.get(
    `/api/channels/${encodeURIComponent(username)}/streams/${encodeURIComponent(streamSessionId)}/play`,
    { signal },
  );
